import styled from 'styled-components';

import { dossierResponsiveMediaQuery } from '../../pages/DossierPage.styles';

export const $FileSummarySections = styled.div`
  @media ${dossierResponsiveMediaQuery} {
    & > div:not(:last-child) {
      margin-bottom: 0.75rem !important;
      padding-bottom: 0.75rem !important;
    }

    & > div > div:first-child {
      margin-bottom: 0.25rem !important;
    }
  }
`;
